<footer class="footer">
  <div class="footer-bottom">
    <span>&copy; {{ currentYear }} Autotaxatie Partners B.V. Alle rechten voorbehouden.</span>
    <div class="footer-bottom-links">
      <a href="https://autotaxatiepartners.nl/privacyverklaring/" target="_blank" rel="noopener">Privacy</a>
      <span class="dot">·</span>
      <a href="https://autotaxatiepartners.nl/voorwaarden/" target="_blank" rel="noopener">Voorwaarden</a>
      <span class="dot">·</span>
      <a href="https://autotaxatiepartners.nl/cookie-statement-2/" target="_blank" rel="noopener">Cookies</a>
      <span class="dot">·</span>
      <a href="https://autotaxatiepartners.nl/copyright-2/" target="_blank" rel="noopener">Copyright</a>
    </div>
  </div>
</footer>